angular.module("kareo.ui.shared.modules.dataServices", [])
.service "k_modelTransformer", =>
  transformObject = (jsonResult, constructor) ->
    model = new constructor()
    angular.extend model, jsonResult
    model

  transformResult = (jsonResult, constructor) ->
    if angular.isArray(jsonResult)
      models = []
      angular.forEach jsonResult, (object) ->
        models.push transformObject(object, constructor)
      return models
    else
      transformObject jsonResult, constructor

  modelTransformer = { transform: transformResult }

  modelTransformer